import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Response_Loading_processing from "../../../../src/layout/Others/Response_Loading_processing";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import Response_Processing from "../../../layout/Others/Response_Processing";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import { toast } from "react-toastify";

function EditSubtitleLanguage(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [editUser, setEditUser] = useState({
    language: "",
    short_code: "",
    id: "",
  });
  const [editname, setEditname] = useState({
    language: "",
  });

  const [message, setMessage] = useState("");
  const access_token = localStorage.getItem("access_token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  useEffect(async () => {
    const getUser = async () => {
      const reqData = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/subtitles/edit/${id}`,
        { headers: headers }
      );
      const resData = await reqData?.json();
      var res = resData?.subtitle;
      setEditUser(res);
      setEditname(res);
    };
    getUser();
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
        {
          headers: headers,
          params: { source: "Subtitle-language" },
        }
      );
      setLabelDisplay(response?.data?.label_management || []);
    } catch (error) {
      console.error("Error fetching label display:", error);
    }
  }, [id]);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setEditUser((prevEditUser) => ({
      ...prevEditUser,
      [name]: value,
    }));

    setValidationMessagelanguage("");
    setIsValidationHiddenlanguage(true);
    setValidationMessageshort_code("");
    setIsValidationHiddenshort_code(true);

    setEditUser({ ...editUser, [e.target.name]: e.target.value });
  };

  const [validationMessagelanguage, setValidationMessagelanguage] =
    useState("");
  const [isValidationHiddenlanguage, setIsValidationHiddenlanguage] =
    useState(true);

  const [validationMessageshort_code, setValidationMessageshort_code] =
    useState("");
  const [isValidationHiddenshort_code, setIsValidationHiddenshort_code] =
    useState(true);

  const [labelDisplay, setLabelDisplay] = useState([]);
  const languageInputRef = useRef(null);
  const short_codeInputRef = useRef(null);
  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  const handleUpdate = async (e) => {
    let focusInputRef = null;

    if (editUser?.language === "") {
      setValidationMessagelanguage("Name cannot be empty.");
      setIsValidationHiddenlanguage(false);
      focusInputRef = languageInputRef;
    }
    if (editUser?.short_code === "") {
      setValidationMessageshort_code("Short Code cannot be empty.");
      setIsValidationHiddenshort_code(false);
      focusInputRef = short_codeInputRef;
    }

    if (focusInputRef) {
      focusInputRef.current.focus();
      return;
    }

    e.preventDefault();

    const editInputvalue = {
      language: editUser?.language,
      short_code: editUser?.short_code,
    };

    let resultapi = null;
    let resjson = null;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/subtitles/update/${id}`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(editInputvalue),
        }
      );

      resjson = await res.json();

      if (resjson.status === true) {
        resultapi = resjson;
        toast.success(resultapi?.message);
      }
    } catch (error) {
      console.error("Error:", error);
      var errorMessage = error?.response?.data?.message;
      toast.error(errorMessage);
    }
  };

  return (
    <>
      <div className=" m-0 p-0">
        <div className="">
          {showOverlay && (<Response_Processing />)}
          {<AdminBackNavigation path={`${'/subtitlelanguage'}`} text="Back" />}
          <AdminSaveHeader heading={labelDisplay?.[0]?.title} saveText={"Update"} saveMethod={handleUpdate} />
          <FormContainer>
            <div className="row col-lg-12">
              <div className="card p-3">
                <h5>{labelDisplay?.[6]?.title}</h5>
                <hr></hr>
                <div className="row">
                  <div className="col-6">
                    <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
                    <AdminCustomInput type="text" name="language" value={editUser?.language} onChange={handleInput} placeHolder={"Enter Language Name"} ref={languageInputRef} error={validationMessagelanguage} />
                  </div>
                  <div className="col-6">
                    <MessageLabel text={labelDisplay?.[7]?.title} className="mandatorySimple" />
                    <AdminCustomInput type="text" name="short_code" value={editUser?.short_code} onChange={handleInput} placeHolder={"Enter Short Code"} ref={short_codeInputRef} error={validationMessageshort_code} />
                  </div>
                </div>
              </div>
            </div>
          </FormContainer>

          {/* <section className="container-fluid">
            <div className="col-lg-12 row py-3">
              <div className="col-6 col-sm-6 col-lg-6">
                <h3>{labelDisplay?.[0]?.title} </h3>
              </div>
              <div className="col-6 col-sm-6 col-lg-6">
                <div className="text-end">
                  <button onClick={handleUpdate} className="btn btn-primary">
                    {labelDisplay?.[5]?.title}
                  </button>
                </div>
              </div>
            </div>
            <div>
              {showOverlay && (
                <div className="overlay-container">
                  <span className="overlay-icon">
                    {" "}
                    <Response_Loading_processing></Response_Loading_processing>
                    Processing ...
                  </span>
                </div>
              )}
            </div>

          </section> */}
        </div>
      </div>
    </>
  );
}
export default EditSubtitleLanguage;
